import { Link } from 'react-router-dom';
import FaqAccordion from '@/components/feature/FaqAccordion';
import { faqs } from '@/mocks/faqs';
import { siteInfo } from '@/mocks/site';

export default function FaqSection() {
  return (
    <section id="faq" className="w-full bg-background-50 scroll-mt-20">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-[0.8fr_1.2fr] gap-10 lg:gap-14">
          <div>
            <span className="text-xs font-medium text-primary-600 tracking-widest">
              FAQ / 常见问题
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
              关于瓜田爆料，你可能想知道的
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              内容来源、更新节奏与浏览方式，都整理在这里。如果还有疑问，欢迎直接写信给我们。
            </p>

            <div className="mt-6 rounded-lg border border-background-200 bg-background-100 p-5">
              <div className="flex items-center gap-2 text-sm font-medium text-foreground-900">
                <i className="ri-mail-send-line text-primary-500"></i>
                直接联系编辑团队
              </div>
              <a
                href={`mailto:${siteInfo.email}`}
                className="mt-2 block text-sm text-primary-700 hover:text-primary-600 transition-colors break-all cursor-pointer"
              >
                {siteInfo.email}
              </a>
              <p className="mt-1 text-xs text-foreground-500">{siteInfo.workingHours}</p>
              <Link
                to="/about#contact"
                className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-foreground-800 hover:text-primary-700 transition-colors cursor-pointer"
              >
                使用联系表单
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>

          <div>
            <FaqAccordion items={faqs} />
          </div>
        </div>
      </div>
    </section>
  );
}